import { ColoursObj } from '@eventr/common-storybook'
import { Divider } from '@mui/material'
export const PageDivider = () => {
    return (
        <Divider
            style={{ marginRight: '-20px', marginLeft: '-20px' }}
            color={ColoursObj.shades.shade4}
        ></Divider>
    )
}
